import request from '@/utils/request'

/**
 *获取财务账号列表
 * @param {*} data 
 */
 export function getAccountList(data){
    return request({
        url:'/account/list',
        method:'post',
        data
    })
}

/**
 *编辑财务账号列表
 * @param {*} data 
 */
 export function upDateAccountList(data){
    return request({
        url:'/account/update',
        method:'post',
        data
    })
}

/**
 *添加财务账号
 * @param {*} data 
 */
 export function addAccountList(data){
    return request({
        url:'/account/add',
        method:'post',
        data
    })
}
/**
 *汇率列表-获取
 * @param {*} data 
 */
 export function getRateList(data){
    return request({
        url:'/rate/list',
        method:'post',
        data
    })
}
/**
 *汇率列表-修改
 * @param {*} data 
 */
 export function updateRate(data){
    return request({
        url:'/rate/update',
        method:'post',
        data
    })
}
/**
 *获取账户流水列表
 * @param {*} data 
 */
 export function getUesrBalance(data){
    return request({
        url:'/userBalance/list',
        method:'post',
        data
    })
}
/**
 *获取VIP用户信息
 * @param {*} data 
 */
 export function getVipCode(data){
    return request({
        url:'/user/selectByCode',
        method:'post',
        data
    })
}
/**
 *充值提交
 * @param {*} data 
 */
 export function deposit(data){
    return request({
        url:'/userBalance/deposit',
        method:'post',
        data
    })
}
/**
 *调账提交
 * @param {*} data 
 */
 export function adjustBalance(data){
    return request({
        url:'/userBalance/adjustBalance',
        method:'post',
        data
    })
}
/**
 *获取优惠信息
 * @param {*} data 
 */
 export function getDiscount(data){
    return request({
        url:'/discount/show',
        method:'post',
        data
    })
}
/**
 *修改优惠信息
 * @param {*} data 
 */
 export function updateDis(data){
    return request({
        url:'/discount/update',
        method:'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/charge.js